<!-- OneTrust Cookies Consent Notice start for beasunhero.com -->
<script>
async function hashEmail (email) {
  const encoder = new TextEncoder()
  const data = encoder.encode(email)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  return Array.from(new Uint8Array(hashBuffer)).map(byte => byte.toString(16).padStart(2, '0')).join('')
}

// Initialize OneTrust with GDPR compliance
async function initializeOneTrust () {
  const userEmail = window.localStorage.getItem('login_email') || 'guest@guest.com' // Replace with actual email
  const hashedEmail = await hashEmail(userEmail)
  window.Optanon = window.Optanon || {}
  window.Optanon.customData = { hashedEmail }
  // Load OneTrust script
  const script = document.createElement('script')
  script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
  script.charset = 'UTF-8'
  script.setAttribute('data-domain-script', '01924851-6f69-7070-9531-cf0cbf5836e0-test')
  document.head.appendChild(script)
}

initializeOneTrust()
</script><!-- OneTrust Cookies Consent Notice end for beasunhero.com -->
<template>
  <section class="orange footer">
    <div class="container">
      <div class="footer-logo">
        <div class="img">
          <img src="@/assets/images/global/footer-logo.gif" alt=""/>
        </div>
      </div>
      <div class="footer-nav">
        <ul>
          <li>
            <a href="https://www.lorealdermatologicalbeauty.us/privacy-policy" target="_blank">Privacy Policy</a>
          </li>
          <li>
            <a href="https://www.lorealdermatologicalbeauty.us/terms-and-conditions" target="_blank">terms of use</a>
          </li>
          <li>
            <a href="https://www.lorealdermatologicalbeauty.us/notice-at-collection" target="_blank">Notice at
              Collection Point</a>
          </li>
          <li>
            <a title="Online Preferences" class="ot-sdk-show-settings">Online Preferences</a>
          </li>
          <li>
            <a href="https://www.lorealdermatologicalbeauty.us/your-privacy-choices" target="_blank">Your Privacy
              Choices <img src="@/assets/privacyoptions29x14.png"></a>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'SunHeroFooter',
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";

.orange.footer {
  background: @color-yellow;

  & > div {
    z-index: 12;
  }

  &:before,
  &:after {
    content: "";
    opacity: 0.5;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      background-size: 50% 100%;
    }
  }

  .container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    padding-top: 0;
    padding-bottom: 0;
    height: 124px;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      flex-flow: column;
      justify-content: center;
      height: 238px;
    }

    h1 {
      position: absolute;
      left: 0;
      width: 100%;
      @media screen and (max-width: ~"@{mq-md-bp}em") {
        position: relative;
      }
    }
  }

  .footer-nav {
    display: flex;

    ul {
      display: inline-flex;
      text-align: center;
      @media (max-width: ~"@{mq-md-bp}em") {
        // margin-left: auto;
        margin-left: -8%;
        position: relative;
        top: -46px;
      }

      li {
        list-style: none;
        text-align: center;
        margin-top: 0;
        margin-left: 20px;
        font-weight: bold;
        font-size: 1.2em;
        text-transform: capitalize;
        text-decoration: underline;
        cursor: pointer;
        @media (max-width: ~"@{mq-md-bp}em") {
          font-size: 12px;
        }
      }
    }
  }

  .footer-logo {
    display: flex;
    margin-right: auto;
    @media (max-width: ~"@{mq-md-bp}em") {
      margin-right: 0;
      position: relative;
      top: -20px;
    }

    img {
      width: 181px;
      height: auto;
      @media (max-width: ~"@{mq-md-bp}em") {
        position: relative;
        top: -14px;
        width: 241px;
      }
    }
  }
}
</style>
